// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1oWj_","large":"styles_large__2ONQc"};